import { ThemeProvider } from '@mui/material';
import { ReactNode, useEffect, useState } from 'react';
import { ThemeContext } from './ThemeContext';
import { darkTheme, lightTheme } from './themes';

export const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  // Read the stored preference synchronously so the first paint is already the
  // right theme — no flash of light for dark-mode users on reload.
  const [isDarkMode, setIsDarkMode] = useState(
    () => localStorage.getItem('preferredTheme') === 'dark'
  );

  useEffect(() => {
    // Update the theme color for PWA/iOS Safari status bar
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute(
        'content',
        isDarkMode ? '#171717' : '#ffffff'
      );
    }
  }, [isDarkMode]);

  const handleSetIsDarkMode = (theme: boolean) => {
    setIsDarkMode(theme);
    localStorage.setItem('preferredTheme', theme ? 'dark' : 'light');
  };

  const toggleTheme = () => handleSetIsDarkMode(!isDarkMode);

  const theme = isDarkMode ? darkTheme : lightTheme;

  return (
    <ThemeContext.Provider
      value={{ isDarkMode, toggleTheme, setIsDarkMode: handleSetIsDarkMode }}
    >
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
